export function AgreementBody({ text, testid = "agreement-body" }) {
  const lines = (text || "").replace(/\r\n/g, "\n").split("\n");
  const blocks = [];
  let list = [];
  const flush = () => {
    if (list.length) blocks.push(<ul key={`ul-${blocks.length}`} className="list-disc pl-6 space-y-1">{list}</ul>);
    list = [];
  };
  lines.forEach((raw, i) => {
    const s = raw.trim();
    if (s.startsWith("- ")) { list.push(<li key={i}>{s.slice(2)}</li>); return; }
    flush();
    if (!s) return;
    if (s.startsWith("## ")) blocks.push(<h3 key={i} className="font-display text-lg text-slate-900 mt-6 mb-1">{s.slice(3)}</h3>);
    else if (s.startsWith("# ")) blocks.push(<h2 key={i} className="font-display text-2xl text-slate-900 mt-4 mb-2">{s.slice(2)}</h2>);
    else if (s.includes("LEGAL REVIEW REQUIRED")) blocks.push(
      <p key={i} className="font-semibold text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="agreement-placeholder-banner">{s}</p>);
    else blocks.push(<p key={i} className="leading-relaxed">{s}</p>);
  });
  flush();
  return <div className="text-sm text-slate-700 space-y-3" data-testid={testid}>{blocks}</div>;
}

export function fmtDate(iso, withTime = false) {
  if (!iso) return "—";
  const d = new Date(iso);
  return withTime
    ? d.toLocaleString("en-CA", { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZone: "UTC", timeZoneName: "short" })
    : d.toLocaleDateString("en-CA", { year: "numeric", month: "short", day: "numeric" });
}

export const TYPE_LABEL = {
  MERCHANT_AGREEMENT: "Merchant Terms & Conditions",
  SHOPPER_TERMS: "Shopper Terms & Conditions",
  PRIVACY_NOTICE: "Privacy Notice",
  MCP_CONNECTOR_TERMS: "MCP Connector Terms",
  AI_FEATURE_TERMS: "AI Feature Terms",
  CASHBACK_TERMS: "Cashback Terms",
  DATA_PROCESSING_ADDENDUM: "Data Processing Addendum",
  API_TERMS: "API Terms",
};

export const typeLabel = (t) => TYPE_LABEL[t] || (t || "").replace(/_/g, " ").toLowerCase().replace(/^\w/, (c) => c.toUpperCase());
